import AXIOS from "./axios";

export class Partner {
  static create(payload) {
    return AXIOS.post("/partners", { partner: payload });
  }
}
